import { handleActions } from "redux-actions";
import { api } from "api";
import { NotificationManager } from "react-notifications";

// ------------------------------------
// Constants
// ------------------------------------
const SET_HOTSPOTS = 'SET_HOTSPOTS';
const SET_TRENDS = 'SET_TRENDS';
const SET_FORECAST = 'SET_FORECAST';
const SET_PREDICTIVE_LOADER = 'SET_PREDICTIVE_LOADER';
const SET_PREDICTIVE_FILTERS = 'SET_PREDICTIVE_FILTERS';

// ------------------------------------
// Actions
// ------------------------------------
const setLoader = loader => ({
    type: SET_PREDICTIVE_LOADER,
    loader,
});

const setHotspots = hotspots => ({
    type: SET_HOTSPOTS,
    hotspots,
});

const setTrends = trends => ({
    type: SET_TRENDS,
    trends,
});

const setForecast = forecast => ({
    type: SET_FORECAST,
    forecast,
});

const setFilters = filters => ({
    type: SET_PREDICTIVE_FILTERS,
    filters,
});

const getHotspots = (params = {}) => (dispatch) => {
    dispatch(setLoader(true));
    api.get('predictive_analysis/hotspots', params)
        .then((response) => {
            dispatch(setHotspots(response));
        })
        .catch(() => {
            NotificationManager.error("Error al obtener puntos calientes", "ERROR", 0);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const getTrends = (params = {}) => (dispatch) => {
    dispatch(setLoader(true));
    api.get('predictive_analysis/trends', params)
        .then((response) => {
            dispatch(setTrends(response));
        })
        .catch(() => {
            NotificationManager.error("Error al obtener tendencias temporales", "ERROR", 0);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const getForecast = (params = {}) => (dispatch) => {
    dispatch(setLoader(true));
    api.get('predictive_analysis/forecast', params)
        .then((response) => {
            dispatch(setForecast(response));
        })
        .catch(() => {
            NotificationManager.error("Error al obtener pronóstico predictivo", "ERROR", 0);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const actions = {
    getHotspots,
    getTrends,
    getForecast,
    setFilters
};

// ------------------------------------
// Reducers
// ------------------------------------
export const reducers = {
    [SET_PREDICTIVE_LOADER]: (state, { loader }) => ({
        ...state,
        loader,
    }),
    [SET_HOTSPOTS]: (state, { hotspots }) => ({
        ...state,
        hotspots: hotspots.clusters || [],
        totalIncidents: hotspots.total_incidents || 0
    }),
    [SET_TRENDS]: (state, { trends }) => ({
        ...state,
        hourlyTrends: trends.hourly_trends || [],
        weeklyTrends: trends.weekly_trends || [],
    }),
    [SET_FORECAST]: (state, { forecast }) => ({
        ...state,
        forecast: forecast.predictions || [],
    }),
    [SET_PREDICTIVE_FILTERS]: (state, { filters }) => ({
        ...state,
        filters: {
            ...state.filters,
            ...filters
        }
    }),
};

export const initialState = {
    loader: false,
    hotspots: [],
    totalIncidents: 0,
    hourlyTrends: [],
    weeklyTrends: [],
    forecast: [],
    filters: {
        emergency_type_id: null,
        days_history: 365
    }
};

export default handleActions(reducers, initialState);
